store = window.store || {};
store.local = store.local || {};

store.local.onInitProduct = function() {
	var $store = $('#store'),
		$buyBox = $store.find('div.buyBox'),
		$ca = $buyBox.find('.customAttribute');

	if ($ca.length < 1) {
		return;
	}
	$ca.find(':input').change(handleAnyChange);
	var timer;
	$ca.find('textarea, input[type=text]').keyup(function() {
		if (timer) {
			clearTimeout(timer);
		}
		timer = setTimeout(handleAnyChange, 300);
	});

	function handleAnyChange() {
		$('#submitCart').removeProp('disabled').removeClass('disabled');
	}
};

store.local.showMessage = function (options) {
	if (options.class_name === 'normal' && options.action === 'cartAdd') {
		// don't show gritter message for add to cart
		return;
	}
	store.message.showGritter(options);
};

site.storeCheckout = {
	init: () => {
		if (document.body.classList.contains('checkout')) {
			$('ul.paymentTypeSelection li').click(function(){
				$(this).siblings().removeClass('selected');
				$(this).addClass('selected');
			});
		}
	}
};
site.inits.push('site.storeCheckout.init()');
